import EmployeePayPage from "./EmployeePayPage";

export default EmployeePayPage;
